/**
 * Saqlangan imkoniyatlar.
 *
 * Yopilganlari ham ko'rsatiladi — foydalanuvchi nima uchun eslatma
 * kelmayotganini bilishi kerak.
 */

import { t } from "../i18n";
import { useEffect, useState } from "react";
import { api, getCached } from "../api";
import { CardList, CardListSkeleton, EmptyState, ErrorView } from "../components";
import { IconBookmark } from "../icons";
import { navigate } from "../router";
import type { FeedResponse } from "../types";

export default function Saved({ active = true }: { active?: boolean }) {
  const [data, setData] = useState<FeedResponse | null>(() => getCached<FeedResponse>("saved:0:20"));
  const [error, setError] = useState<string | null>(null);
  const [hasBeenActive, setHasBeenActive] = useState(active);

  useEffect(() => {
    if (active && !hasBeenActive) {
      setHasBeenActive(true);
    }
  }, [active, hasBeenActive]);

  async function load() {
    setError(null);
    try {
      const fresh = await api.saved();
      setData(fresh);
    } catch (err) {
      if (!data) {
        setError(err instanceof Error ? err.message : t("common.loadFailed"));
      }
    }
  }

  useEffect(() => {
    if (hasBeenActive) {
      void load();
    }
  }, [hasBeenActive]);

  if (error && !data) return <ErrorView message={error} onRetry={load} />;
  if (!data) return <div className="screen"><CardListSkeleton count={3} /></div>;

  if (!data.items.length) {
    return (
      <EmptyState
        icon={<IconBookmark size={26} />}
        title={t("saved.empty")}
        hint={t("saved.emptyHint")}
        action={
          <button
            className="btn btn-primary"
            type="button"
            onClick={() => navigate({ name: "home" })}
          >
            {t("saved.browse")}
          </button>
        }
      />
    );
  }

  return (
    <div className="screen">
      <p className="muted small">{data.total} ta saqlangan</p>
      <CardList items={data.items} source="feed" />
    </div>
  );
}
